import { render } from "./MenuCollapse.vue?vue&type=template&id=bbe850f6&scoped=true"
import script from "./MenuCollapse.vue?vue&type=script&lang=js"
export * from "./MenuCollapse.vue?vue&type=script&lang=js"

import "./MenuCollapse.vue?vue&type=style&index=0&id=bbe850f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe850f6"]])

export default __exports__